import { render, staticRenderFns } from "./LevelButton.vue?vue&type=template&id=8ce09540&scoped=true&"
import script from "./LevelButton.vue?vue&type=script&lang=js&"
export * from "./LevelButton.vue?vue&type=script&lang=js&"
import style0 from "./LevelButton.vue?vue&type=style&index=0&id=8ce09540&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce09540",
  null
  
)

export default component.exports